module.exports = __webpack_public_path__ + "static/media/StyleScript.0a26c77f.ttf";